import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {PageViewModel} from '@components/ui/table-template/models/page-view-model';
import {EntityAssetViewModel} from '../view-models/entity-asset.view-model';

import {EntityAssetCardComponent} from '../entity-asset-card/entity-asset-card.component';

@Component({
    selector: 'app-entity-asset-card-container',
    templateUrl: './entity-asset-card-container.component.html',
    styleUrls: ['./entity-asset-card-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [EntityAssetCardComponent]
})
export class EntityAssetCardContainerComponent {

  public readonly currentPage = input.required<PageViewModel<EntityAssetViewModel>>();

  public readonly cardClicked = output<EntityAssetViewModel>();

  handleCardClicked(entityAssetVM: EntityAssetViewModel): void {
    this.cardClicked.emit(entityAssetVM);
  }
}
